import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { DialogMotivoInasistenciaRequest, DialogMotivoInasistenciaResponse, MotivoInasistencia, SearchMotivoInasistenciaRequest } from '../../../../../src/app/shared/model';
import { MotivoInasistenciaService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-dialogMotivoInasistencia',
  templateUrl: 'dialogMotivoInasistencia.component.html',
  styleUrls: ['./dialogMotivoInasistencia.component.css']
})

export class DialogMotivoInasistenciaComponent implements OnInit {

  public title: string;
  public message: string;
  public buttonAcceptText: string;
  public buttonCancelText: string;
  isSearching: boolean = false;
  isMotivoInasisSerching: boolean;

  formGroup: FormGroup;
  motivoInasistenciaList: MotivoInasistencia[];
  filteredMotivoInasistencia: MotivoInasistencia[];
  horas: number = 0;
  autoFocus: false;

  constructor(
    private dialogRef: MatDialogRef<DialogMotivoInasistenciaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogMotivoInasistenciaRequest,
    private formBuilder: FormBuilder,
    private motivoInasistenciaService: MotivoInasistenciaService,
    private sharedFunctions: SharedFunctions,
    ) {

  }

  ngOnInit() {
    this.getMotivoInasistenciaMotivo();

    if(!this.data.TipoAsistencia){
      this.title = "Impedimento";
      this.message = "Impedimento de trabajo día <strong>" + this.data.FechaSeleccionada + "</strong> en <strong>" +  this.data.ObraSeleccionada + "</strong>"
    }else if(this.data.TipoAsistencia == 1){
      this.title = "Baja Medica";
      this.message = "Cantidad de horas de Baja Medica el día <strong>" + this.data.FechaSeleccionada + "</strong> en <strong>" + this.data.ObraSeleccionada + "</strong>"
    }else if(this.data.TipoAsistencia == 2){
      this.title = "Presente";
      this.message = "Cantidad de horas trabajadas el día <strong>" + this.data.FechaSeleccionada + "</strong> en <strong>" + this.data.ObraSeleccionada + "</strong>"
    }

    this.buttonAcceptText = 'Aceptar';
    this.buttonCancelText = 'Cancelar';
    this.loadView();
  }

  loadView(){
    this.isSearching = true;
    this.buildForm();
    this.loadEntity();
  }

  buildForm(){
    this.formGroup = this.formBuilder.group({
      'MotivoInasistencia':[null],
      'HorasAsistencia':[null]
    });
  }

  loadEntity(){
    const exist = this.data.ListaAsistencia.find(x => x.Asistencia == this.data.TipoAsistencia && x.FechaAsistencia.toString() == this.data.FechaAsistencia && x.EmpleadoId == this.data.EmpleadoId);
    if(!exist)
      return;
    this.formGroup.patchValue(exist);
    this.formGroup.get("MotivoInasistencia")?.patchValue(this.motivoInasistenciaList?.find(x => x?.Id == exist?.MotivoInasistenciaId))
    if(this.data.EsDia)
      this.motivoInasistenciaList = this.motivoInasistenciaList?.filter(x => x?.Id == exist?.MotivoInasistenciaId || x?.Tipo == 1)
    else
      this.motivoInasistenciaList = this.motivoInasistenciaList?.filter(x => x?.Id == exist?.MotivoInasistenciaId || x?.Tipo == 2)
    /* this.setMotivoInasistenciaForm(); */
  }

 /*  setMotivoInasistenciaForm() {
    if (this.motivoInasistenciaList != null && this.motivoInasistenciaList.length > 0 && this.formGroup.get("MotivoInasistencia")?.value != null) {
        var u = this.motivoInasistenciaList.filter(f => f.Id == this.data.);
        if (u != null && u.length > 0)
          this.formGroup.get("MotivoInasistencia")?.setValue(u[0]);
    }
  } */

  getMotivoInasistenciaMotivo(){
    this.isMotivoInasisSerching = true;
    if(!this.data.EsDia)
      var r = new SearchMotivoInasistenciaRequest(null, null, true, "Nombre", null, 2, true);
    else
      var r = new SearchMotivoInasistenciaRequest(null, null, true, "Nombre", null, 1, true);

    var r = new SearchMotivoInasistenciaRequest(null, null, true, "Nombre", null, null, true);
    this.motivoInasistenciaService.searchMotivoInasistencia(r).subscribe(data => {
      this.isMotivoInasisSerching = false;
      if (data != null) {
        this.motivoInasistenciaList = data?.result;
        this.loadEntity();
      }
    },
    (err: HttpErrorResponse) => {
      this.isMotivoInasisSerching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  displayMotivo(motivo: MotivoInasistencia): string{
    return motivo?.Nombre ? motivo.Nombre : "";
  }

  saveMotivoInasistencia(){
    if(this.data.TipoAsistencia == 2 && new Date(this.data.FechaAsistencia ?? "") > new Date()) {
      this.sharedFunctions.showMessage("No se puede asignar presentismo mas alla de la fecha actual", "Error");
      return;
    }

    this.dialogRef.close(new DialogMotivoInasistenciaResponse(this.formGroup.value?.MotivoInasistencia?.Id, this.formGroup.value?.HorasAsistencia, this.data?.EmpleadoId, this.data.FechaAsistencia, this.data?.TipoAsistencia ? this.data?.TipoAsistencia: 1, true, this.data.EsDia));
  }

  onAccept() {
    this.saveMotivoInasistencia();
  }

  onDecline() {
    this.dialogRef.close(new DialogMotivoInasistenciaResponse(null, null, null, null, null, false, null));
  }
}
